import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@shared/components/ui/shadcn/dialog';
import { Product } from '@shared/components/ui/Product';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { OrderPack } from '../../models/Order';

export interface PackContentsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  pack: OrderPack | null;
}

export const PackContentsModal: FC<PackContentsModalProps> = ({ open, onOpenChange, pack }) => {
  const { t } = useTranslation('viewOrdersModule');
  const lines = pack?.lines?.filter((l) => l.product && l.product.id && l.product.code) ?? [];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-body-bg border-card-border max-w-lg max-h-[90dvh] overflow-y-auto sm:max-w-lg"
        data-testid="pack-contents-dialog"
      >
        <DialogHeader>
          <DialogTitle className="text-foreground">
            {pack?.title ?? t('modals.pack-contents.fallback-title')}
          </DialogTitle>
        </DialogHeader>
        {lines.length === 0 ? (
          <p className="text-sm text-complementary-text py-2 transition-colors">{t('modals.pack-contents.empty')}</p>
        ) : (
          <ul className="space-y-0 divide-y divide-card-border border border-card-border rounded-md overflow-hidden transition-colors">
            {lines.map((line) => (
              <li key={`${line.product_id}-${line.product.id}`} className="p-3 bg-card-bg transition-colors">
                <div className="flex items-center justify-between gap-3">
                  <Product
                    id={line.product.id}
                    name={line.product.name}
                    code={line.product.code}
                    src={line.product.image_hash ?? ''}
                    showImageModal={!!line.product.image_hash}
                    enableLineClamp={true}
                    className="min-w-0 flex-1"
                    data-testid={`pack-contents-line-${line.product.id}`}
                  />
                  <span className="text-sm text-foreground whitespace-nowrap tabular-nums shrink-0">× {line.qty}</span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </DialogContent>
    </Dialog>
  );
};
